<div class="container">
  <div class="wrapper">
    <button class="btn">
      <span
        ><img
          src="../../../../assets/img/icons/arrow-left.svg"
          alt="icon arrow left" /></span
      ><span>Retour</span>
    </button>
    <div class="user">
      <h1 class="status">Data administrator</h1>
      <div class="location">
        <div class="ville">
          <span
            ><img
              src="../../../../assets/img/icons/location.svg"
              alt="icon loaction"
          /></span>
          <span>Dakar</span>
        </div>
        <div class="duration">
          <span
            ><img src="../../../../assets/img/icons/clock.svg" alt="icon clock"
          /></span>
          <span>Permanent</span>
        </div>
      </div>
    </div>
  </div>
</div>
